module.exports = __webpack_public_path__ + "img/vip.50fc809c.png";